import { render } from "./mensajefinal_ingles.vue?vue&type=template&id=2ffab3d9&scoped=true"
import script from "./mensajefinal_ingles.vue?vue&type=script&lang=js"
export * from "./mensajefinal_ingles.vue?vue&type=script&lang=js"

import "./mensajefinal_ingles.vue?vue&type=style&index=0&id=2ffab3d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ffab3d9"]])

export default __exports__